import { render, staticRenderFns } from "./pdf-file-svg.vue?vue&type=template&id=371ee965&scoped=true&"
var script = {}
import style0 from "./pdf-file-svg.vue?vue&type=style&index=0&id=371ee965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ee965",
  null
  
)

export default component.exports